/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_TitleInputs */

const en_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual Voice Manager`)
};

const fr_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de voix virtuelles`)
};

const de_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtueller Sprachmanager`)
};

const it_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestore vocale virtuale`)
};

const ru_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виртуальный голосовой менеджер`)
};

const es_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de voz virtual`)
};

const zh_cn2_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虚拟语音管理器`)
};

const ja_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仮想音声マネージャー`)
};

const hi_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्चुअल वॉयस मैनेजर`)
};

const pt_pt2_voice_manager_title = /** @type {(inputs: Voice_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Voz Virtual`)
};

/**
* | output |
* | --- |
* | "Virtual Voice Manager" |
*
* @param {Voice_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_title = /** @type {((inputs?: Voice_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_title(inputs)
	if (locale === "de") return de_voice_manager_title(inputs)
	if (locale === "it") return it_voice_manager_title(inputs)
	if (locale === "ru") return ru_voice_manager_title(inputs)
	if (locale === "es") return es_voice_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_title(inputs)
	if (locale === "ja") return ja_voice_manager_title(inputs)
	if (locale === "hi") return hi_voice_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_title(inputs)
	return en_voice_manager_title(inputs)
});